/**
 * Component: Base
 * ------------------------------------------------------------------------------
 * IMPORTANT: This is the legacy entry-file for site-wide components,
 * based off Shopify's Slate.
 * - Some of it is unused, some of it is still used but due to be replaced.
 * - New code should not be added to this file and/or section without good
 *   reason.
 * - The general aim should be to remove items from this file, not add to it.
 */
require("./libraries/prepare-transition");
require("./libraries/jquery.ba-throttle-debounce");
require("./libraries/tmpl");
require("./libraries/search");
import _ from 'lodash-es';

window._ = _;

window.theme = window.theme || {};

import Sections from "./core-theme/ThemeSections";
import slate from "./core-theme/ThemeSlate";
import eventBus from "./core-theme/ThemeEventBus";
import Images from "./core-theme/ThemeImages";
import currency from "./core-theme/ThemeCurrency";
import slateVariants from "./core-theme/ThemeSlateVariants";
import variants2 from "./core-theme/ThemeVariants2";
import Slideshow from "./core-theme/ThemeSlideshow";
import CustomerTemplates from "./core-theme/ThemecustomerTemplates";
import Cart from "./core-theme/ThemeCart";
import ThemeSlick from "./core-theme/ThemeSlick";
import haloAddOn from "./core-theme/ThemeHaloAddOn";

/* ================ TEMPLATES ================ */
document.addEventListener("DOMContentLoaded", function() {
  var sections = new theme.Sections();

  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("slideshow", theme.Slideshow);
  sections.register("lookbook-template", theme.Lookbook);

  theme.HaloAddOn.init();
  theme.ThemeSlick().init();

  window.addEventListener(
    "resize",
    () => {
      theme.ThemeSlick().init();
    },
    { passive: true }
  );
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table";

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: "scrollable-wrapper"
  });

  //// Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $("a[href]:not([aria-describedby], .product-single__thumbnail)")
  });

  var selectors = {
    image: "[data-image]",
    imagePlaceholder: "[data-image-placeholder]",
    imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]",
    lazyloaded: ".lazyloaded"
  };
  var classes = {
    hidden: "hide"
  };

  $(document).on("lazyloaded", function(e) {
    var $target = $(e.target);

    if ($target.data("bgset")) {
      var $image = $target.find(selectors.lazyloaded);
      if ($image) {
        if ($target.data("bg")) {
          $image.attr("src", $target.data("bg"));
        }
        if ($target.data("alt")) {
          $image.attr("alt", $target.data("alt"));
        }
      }
    }

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });
};

// Check if jQuery is loaded on window
document.addEventListener("DOMContentLoaded", function() {
  if (window.jQuery) {
    $(theme.init);
  }
});
